/* eslint-disable react/prop-types */
import { Alert, Box, Collapse } from '@mui/material'

/**
 * Props for the CustomSnackbarMassApprovalOk component.
 */
interface CustomSnackbarMassApprovalOkProps {
	isOpen: boolean
	closeHandler: () => void
}

/**
 * Shows a success snackbar indicating that timesheets without changes have been approved.
 * It is controlled by the parent component via the isOpen and the closeHandler props.
 * - @param isOpen - Controls whether the snackbar is open
 * - @param closeHandler - Function to handle closing the snackbar
 * - @returns JSX.Element representing the CustomSnackbarMassApprovalOk component
 */
const CustomSnackbarMassApprovalOk: React.FC<CustomSnackbarMassApprovalOkProps> = ({ isOpen, closeHandler }) => {
	return (
		<Box sx={{ width: '100%', position: 'absolute', top: '-24px', left: 0, zIndex: 999 }}>
			<Collapse
				in={isOpen}
				timeout={150}
				easing={'ease'}
				exit={true}
			>
				<Alert
					variant='filled'
					severity='success'
					title='Folhas de Ponto sem Alterações Aprovadas'
					aria-description='Snackbar de aprovação em massa bem-sucedida'
					onClose={closeHandler}
					sx={{
						height: '37px',
						padding: '0 16px',
						fontFamily: 'var(--font-family)',
						fontSize: '14px',
						fontWeight: 500,
						letterSpacing: '0.15px',
						lineHeight: '150%',
						background: 'linear-gradient(86deg, #16C53D -57.78%, #00A5FF 115.35%)',
					}}
				>
					Folhas de Ponto sem Alterações Aprovadas
				</Alert>
			</Collapse>
		</Box>
	)
}

export default CustomSnackbarMassApprovalOk
